import { action, makeObservable, observable } from 'mobx';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';

class MarketsStore {
  markets = [];

  currentMarketAmount = gameConfigStore?.limits?.defaultBetAmount || gameConfigStore.limits.minBet;

  disabledMarkets = [];

  isLoadingBetButton = false;

  isLoadingReBetButton = false;

  currentClickedMarket = '';

  totalWin = 0;

  marketBetData = {
    isMarketNextRoundBet: false,
    amount: null,
    market: {},
  };

  betsMarketData = [];

  isDisabledMarketsSection = false;

  isDisabledMarketBetButton = false;

  betMarketsData = [];

  constructor() {
    makeObservable(this, {
      markets: observable,
      totalWin: observable,
      betsMarketData: observable,
      disabledMarkets: observable,
      isLoadingBetButton: observable,
      isLoadingReBetButton: observable,
      currentMarketAmount: observable,
      currentClickedMarket: observable,
      isDisabledMarketsSection: observable,
      isDisabledMarketBetButton: observable,
      getMarkets: action.bound,
      setIsNexRoundBet: action.bound,
      setTotalWin: action.bound,
      setIsLoadingBetButton: action.bound,
      setIsLoadingReBetButton: action.bound,
      resetDisabledMarkets: action.bound,
      changeMarketBetData: action.bound,
      updateDisabledMarkets: action.bound,
      setCurrentClickedMarket: action.bound,
      setIsDisabledMarketsSection: action.bound,
      changeCurrentMarketAmount: action.bound,
      updateIsDisabledMarketBetButton: action.bound,
    });
  }

  changeMarketBetData(marketData) {
    this.marketBetData = {
      ...this.marketBetData,
      market: marketData,
    };
  }

  resetMarketBetData() {
    this.currentMarketAmount =
      gameConfigStore.limits.defaultBetAmount || gameConfigStore.limits.minBet;
    this.marketBetData = {
      isMarketNextRoundBet: false,
      amount: null,
      market: {},
    };
    this.currentClickedMarket = '';
    this.isDisabledMarketsSection = false;
  }

  setBetsMarketData(marketData) {
    if (marketData) {
      this.betMarketsData = [...this.betsMarketData, marketData];
    } else {
      this.betsMarketData = [];
    }
  }

  setTotalWin(totalWinAmount) {
    this.totalWin = totalWinAmount;
  }

  updateDisabledMarkets(disabledMarket) {
    this.disabledMarkets = [...this.disabledMarkets, disabledMarket];
  }

  setIsNexRoundBet(isMarketNextRoundBet) {
    this.marketBetData = {
      ...this.marketBetData,
      isMarketNextRoundBet,
    };
    this.setIsDisabledMarketsSection(isMarketNextRoundBet);
  }

  setIsDisabledMarketsSection(isDisabled) {
    this.isDisabledMarketsSection = isDisabled;
  }

  updateIsDisabledMarketBetButton(isDisable) {
    this.isDisabledMarketBetButton = isDisable;
  }

  setCurrentClickedMarket(market) {
    this.currentClickedMarket = market;
  }

  resetDisabledMarkets() {
    this.disabledMarkets = [];
  }

  getMarkets(markets) {
    this.markets = markets;
  }

  changeCurrentMarketAmount(amount) {
    this.currentMarketAmount = amount;
  }

  setIsLoadingBetButton(isLoading) {
    this.isLoadingBetButton = isLoading;
  }

  setIsLoadingReBetButton(isLoading) {
    this.isLoadingReBetButton = isLoading;
  }
}

export const marketsStore = new MarketsStore();
